// icons
import { Icon, IconifyIcon } from '@iconify/react';

// @mui
import { Box, SxProps, BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

interface Props extends Omit<BoxProps, 'width' | 'height'> {
  sx?: SxProps;
  icon: IconifyIcon | string;
  width?: number | string;
  height?: number | string;
  mb?: number | string;
  mt?: number | string;
  ml?: number | string;
  mr?: number | string;
  m?: number | string;
}

export default function Iconify({ icon, sx, width, height, mb, mt, ml, mr, m, ...other }: Props) {
  return (
    <Box component={Icon} icon={icon} sx={{ width, height, mb, mt, ml, mr, m, ...sx }} {...other} />
  );
}
